import { CreateForm, FormTemplateProps, FormFieldsData } from 'framework/form';
import { CreateTimelineItemLayout } from 'framework/ui/timeline';
import NoteForm from 'domain/sales/shared/timeline/note/form/NoteForm';
import useCrmStrategyNoteService from '../crmStrategyNoteService';

interface CreateStrategyNoteFormProps extends FormTemplateProps {
  onCancel: () => void;
  submitFormFunc: (values: FormFieldsData) => Promise<object | void>;
}

const CreateStrategyNoteForm = ({ submitFormFunc, onCancel, ...props }: CreateStrategyNoteFormProps) => {
  const { getValidationSchema } = useCrmStrategyNoteService();

  return (
    <CreateForm
      submitFormFunc={async (values: FormFieldsData) => {
        const response = await submitFormFunc(values);
        return {
          ...response,
          isPinned: true,
        };
      }}
      getValidationSchemaFunc={getValidationSchema}
      {...props}
    >
      <CreateTimelineItemLayout onCancel={onCancel}>
        <NoteForm isStrategy />
      </CreateTimelineItemLayout>
    </CreateForm>
  );
};

export default CreateStrategyNoteForm;
